module.exports = __webpack_public_path__ + "static/media/frown-regular.37f1170c.svg";